import { Box, Grid, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";

import { mdHeight, xsHeight } from "../AppBar";
import { tabsOffset } from "../TabLinks";

export function DashboardLayout(props: PropsWithChildren<unknown>) {
  const theme = useTheme();
  const backgroundColor = theme.palette.canvas;

  return (
    <Box
      sx={{
        padding: theme.spacing(2),
        background: backgroundColor,
        minHeight: {
          xs: `calc(100vh - ${theme.spacing(xsHeight + tabsOffset)})`,
          md: `calc(100vh - ${theme.spacing(mdHeight + tabsOffset)})`,
        },
      }}
    >
      <Grid container spacing={2}>
        {props.children}
      </Grid>
    </Box>
  );
}
